import {usePermissions} from "../PermissionsContext";
import {AppBar, Box, capitalize, Divider, List, ListItem, ListItemText, Toolbar, Typography,} from "@mui/material";
import {ExpandContextProvider} from "../../expand";
import Logo from "../Logo";
import React from "react";
import {DashboardIcon} from "../icons";
import {apiUrl, applicationVersion, applicationVersionTime} from "../../config";
import MultipleGuard from "../guards/MultipleGuard";
import {permissions} from "../../permissions";
import {mainmenuStyles} from "../../styles/mainmenu.styles";
import NavButtonWithIcon from "./NavButtonWithIcon";
import {Apartment, Build, Phone, Schedule, Task} from "@mui/icons-material";
import {useMainMenuHandling} from "../../hooks/useMainMenuHandling";


export function MainMenu({close}: { close: () => void }) {
    const {translation} = useMainMenuHandling();
    const userPermissions = usePermissions();
    const isMandantAnrufer = userPermissions.includes(permissions.roles.mandantAnrufer);
    const aufgabenNavigation = (
        <MultipleGuard permissions={[
            permissions.aufgaben.list,
            permissions.aufgaben.own_list,
            permissions.mandanten.list,
            permissions.mandanten.own_list,
        ]}>
            <NavButtonWithIcon id={'main-menu-collapse-list-stammdaten-navbutton-aufgaben'}
                               route={'/aufgaben'}
                               primaryLabel={capitalize(translation('tasks'))}
                               onClick={close}
                               icon={Task}
            />
        </MultipleGuard>
    );

    return (
        <ExpandContextProvider id="menu" store>
            <Box
                sx={mainmenuStyles.mainmenu.boxContainer}
            >
                <AppBar
                    position="static"
                    color="primary"
                    elevation={0}
                    sx={mainmenuStyles.mainmenu.appBar}
                >
                    <Toolbar sx={mainmenuStyles.mainmenu.toolBar}>
                        <Box
                            component={Logo}
                            sx={mainmenuStyles.mainmenu.toolBarBox}
                            width={55}
                            height={55}
                            fillWhite={true}
                        />
                        <Box sx={mainmenuStyles.mainmenu.titleBox}>
                            <Typography variant="h6" sx={mainmenuStyles.mainmenu.title}>Guude.ai</Typography>
                            <Typography variant="subtitle2" sx={mainmenuStyles.mainmenu.subtitle}>{capitalize(translation("appSubtitle"))}</Typography>
                        </Box>
                    </Toolbar>
                    {isMandantAnrufer ? aufgabenNavigation : (
                        <>
                            <Box sx={mainmenuStyles.mainmenu.appBarBox}>
                                <List>
                                    <NavButtonWithIcon id={'main-menu-appbar-dashboard-navbutton'}
                                                       route={'/'}
                                                       primaryLabel={capitalize(translation("dashboard"))}
                                                       onClick={close}
                                                       icon={DashboardIcon}
                                    />
                                </List>
                            </Box>
                            <MultipleGuard permissions={[
                                permissions.mandanten.list,
                                permissions.mandanten.own_list,
                            ]}>
                                <NavButtonWithIcon id={'main-menu-navbutton-mandanten'}
                                                   route={'/mandanten'}
                                                   primaryLabel={capitalize(translation('clients'))}
                                                   onClick={close}
                                                   icon={Apartment}
                                />
                            </MultipleGuard>
                            <MultipleGuard permissions={[
                                permissions.phonenumbers.show,
                                permissions.phonenumbers.edit,
                            ]}>
                                <NavButtonWithIcon id={'main-menu-navbutton-phonenumbers'}
                                                   route={'/phonenumbers'}
                                                   primaryLabel={capitalize(translation('phonenumbers'))}
                                                   onClick={close}
                                                   icon={Phone}
                                />
                            </MultipleGuard>
                            <MultipleGuard permissions={[
                                permissions.tools.edit,
                            ]}>
                                <NavButtonWithIcon id={'main-menu-navbutton-tooling'}
                                                   route={'/tooling'}
                                                   primaryLabel={capitalize(translation('tooling'))}
                                                   onClick={close}
                                                   icon={Build}
                                />
                            </MultipleGuard>
                            <MultipleGuard permissions={[
                                permissions.schedulers.list,
                                permissions.schedulers.own_list,
                            ]}>
                                <NavButtonWithIcon id={'main-menu-navbutton-schedulers'}
                                                   route={'/schedulers'}
                                                   primaryLabel={capitalize(translation('schedulers'))}
                                                   onClick={close}
                                                   icon={Schedule}
                                />
                            </MultipleGuard>
                            {aufgabenNavigation}
                        </>
                    )}
                </AppBar>
                {apiUrl.includes("localhost") ||
                apiUrl.includes("test") ||
                apiUrl.includes("staging") ? (
                    <List>
                        <Divider/>
                        <ListItem>
                            <ListItemText
                                inset
                                primary={<>Version {applicationVersion}</>}
                                secondary={<>{applicationVersionTime}</>}
                                primaryTypographyProps={{
                                    variant: "caption",
                                    style: {color: "black", fontSize: "11pt"},
                                }}
                            />
                        </ListItem>
                    </List>
                ) : (
                    <></>
                )}
            </Box>
        </ExpandContextProvider>
    );
}
